var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", [_vm._v("Employee Check-In/Out Locations")]),
      _vm._v(" "),
      _c(
        "gmaps-map",
        { staticStyle: { height: "50vh" }, attrs: { options: _vm.mapOptions } },
        _vm._l(_vm.markers, function(item, i) {
          return _c("gmaps-marker", {
            key: i,
            attrs: { options: item.options }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }